define([
	"dojo/_base/declare",
	"./CopyThemeController"
], function(declare,Copy) {

	return declare(Copy, {
		idOwnerRelation: "Themes"
	});
});